import React, { useState } from 'react';
import UsersManager from './views/UsersManager';
import ProfessionalsManager from './views/ProfessionalsManager';
import EventsManager from './views/EventsManager';
import EventRegistrationsManager from './views/EventRegistrationsManager';
import SendEmailManager from './views/SendEmailManager';
import DashboardManager from './views/DashboardManager';
import AdminNavigation from './AdminNavigation';
import './style/admin.css';

const tabs = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'professionals', label: 'Professionals' },
  { id: 'users', label: 'Users' },
  { id: 'events', label: 'Events' },
  { id: 'registrations', label: 'Registrations' },
  { id: 'email', label: 'Send Email' },
];

export default function AdminDashBoard() {
  const [currentTab, setCurrentTab] = useState('dashboard');
  const [emailPrefill, setEmailPrefill] = useState(null);

  const handleOpenEmail = (payload) => {
    setEmailPrefill(payload);
    setCurrentTab('email');
  };

  return (
    <div className="admin-container">
      <aside className="admin-sidebar">
        <AdminNavigation tabs={tabs} currentTab={currentTab} onSelectTab={setCurrentTab} />
      </aside>

      <div className="admin-body-wrapper">
        <main className="admin-main-content">
          {currentTab === 'dashboard' && <DashboardManager />}
          {currentTab === 'professionals' && <ProfessionalsManager onSendEmail={handleOpenEmail} />}
          {currentTab === 'users' && <UsersManager onSendEmail={handleOpenEmail} />}
          {currentTab === 'events' && <EventsManager />}
          {currentTab === 'registrations' && <EventRegistrationsManager onSendEmail={handleOpenEmail} />}
          {currentTab === 'email' && <SendEmailManager prefill={emailPrefill} />}
        </main>
      </div>
    </div>
  );
}